export function requestIdleWork(callback, options = {}) {
  if (typeof window === "undefined") {
    return null;
  }
  if (window.requestIdleCallback) {
    return { type: "idle", id: window.requestIdleCallback(callback, options) };
  }
  return { type: "timeout", id: window.setTimeout(callback, options.timeout ?? 0) };
}

export function cancelIdleWork(handle) {
  if (typeof window === "undefined" || !handle) {
    return;
  }
  if (handle.type === "idle" && window.cancelIdleCallback) {
    window.cancelIdleCallback(handle.id);
    return;
  }
  window.clearTimeout(handle.id);
}
